import React from "react";
import { SnackbarProvider } from "notistack";
import { AuthProvider } from "./auth/authContext";
import ErrorBoundary from "./errors/errorBoundary";
import { NotificationProvider } from "./shared/notifications/notifications";
import { AppNotificationProvider } from "./shared/components/providers/appNotifications";

import AppRoutes from "./AppRoutes";
import Layout from "./Layout";

const App = () => (
  <SnackbarProvider
    maxSnack={3}
    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    autoHideDuration={4000}
  >
    <AppNotificationProvider>
      <NotificationProvider>
        <AuthProvider>
          <ErrorBoundary>
            <Layout>
              <AppRoutes />
            </Layout>
          </ErrorBoundary>
        </AuthProvider>
      </NotificationProvider>
    </AppNotificationProvider>
  </SnackbarProvider>
);

export default App;
